/* eslint-disable react/require-default-props */
import React, { ReactNode, ReactElement, useCallback } from "react";
import { Modal as Dialog } from "react-bootstrap";

import "./Modal.scss";
import ModalHeader from "./components/ModalHeader";
import ModalBody from "./components/ModalBody";
import ModalFooter from "./components/ModalFooter";
import ModalDialog from "./components/ModalDialog";

type ModalProps = {
  children: ReactNode;
  show: boolean;
  onHide: () => void;
  size?: "sm" | "md" | "lg" | "xl" | "tracking";
  closeWithBackdropClick?: boolean;
  closeWithEscape?: boolean;
};

const Modal = function (props: ModalProps) {
  const { children, closeWithBackdropClick = true, closeWithEscape = true, show, onHide, size = "lg" } = props;

  return (
    <Dialog
      backdropClassName="cb-modal__backdrop"
      show={show}
      dialogAs={useCallback(
        (dialogProps) => (
          <ModalDialog {...dialogProps} {...(closeWithBackdropClick && { onHide })} size={size} />
        ),
        [closeWithBackdropClick, size],
      )}
      {...(closeWithEscape && { onEscapeKeyDown: onHide })}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as ReactElement<any>, { onHide, size });
        }
        return child;
      })}
    </Dialog>
  );
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
